﻿import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';
import getResultPresentationByLayoutName from 'layout/services/resultsPresentationService';

const uiStateSlice = createSlice({
  name: 'uiState',
  initialState: {
    isFetchingModal: false,
    modalInformation: null,
  },
  reducers: {
    clearModal: (state) => {
      state.isFetchingModal = false;
      state.modalInformation = null;
    },
    fetchModal: (state, action) => {
      state.isFetchingModal = action.payload.isFetchingModal;
    },
    fetchModalError: (state) => {
      state.isFetchingModal = false;
    },
    fetchModalFulfilled: (state) => {
    state.isFetchingModal = false;
    },
    updatePageLayout: (state, action) => {
      state.pageLayout = action.payload;
      state.resultsPresentationType = getResultPresentationByLayoutName(action.payload);
    },
    updateCardGridSkeleton: (state, action) => {
      state.displayCardGridSkeleton = action.payload === LoadingStatus.Loading;
    },
    focusedListingInformation: (state, action) => {
      state.focusedListing = action.payload;
    },
    modalInformation: (state, action) => {
      const previousName = state.modalInformation?.name;
      const newModalInformation = {...action.payload};
      // We don't need to save the events information into the state. So
      // we are removing them before assigning to the state.
      delete newModalInformation.googleAnalyticsDTO;

      state.modalInformation = {
        ...state.modalInformation,
        ...newModalInformation,
      };

      // the "previousName" property should change only when a new name is being set
      if (previousName) {
        state.modalInformation.previousName = previousName;
      }
    },
    updateLayoutBreakpoint: (state, action) => {
      state.layoutBreakpoint = action.payload;
    },
    /* A reducer that does nothing because it's used for Google Analytics Redux Beacon. */
    trackUserEvent: () => {},
  },
});

export default uiStateSlice;
